import React from 'react';
export const ChatTestimonials = () => {
  const testimonials = [{
    initial: 'L',
    name: 'Liset',
    time: '21:29',
    text: 'Super bedankt. Was boeiend en leerzaam.',
    color: 'bg-purple-500'
  }, {
    initial: 'L',
    name: 'Linda',
    time: '21:39',
    text: 'leuk filmpje :-) Zie mezelf en mijn "hondenkleinkids" :))) aangenaam verast. Dankjewel voor de masterclass',
    color: 'bg-blue-500'
  }, {
    initial: 'K',
    name: 'Karin',
    time: '21:40',
    text: 'Heel erg bedankt, het was heel leerzaam',
    color: 'bg-green-500'
  }, {
    initial: 'A',
    name: 'Annemieke',
    time: '21:40',
    text: 'heel erg bedankt voor de masterclass! groetjes, Annemieke',
    color: 'bg-pink-500'
  }, {
    initial: 'C',
    name: 'Corrie',
    time: '21:40',
    text: 'Bedankt voor je heldere uitleg! Fijne avond',
    color: 'bg-orange-500'
  }];
  const emailTestimonial = {
    from: 'Jessica',
    to: 'mij',
    subject: 'Hi Amee,',
    text: 'Super, het is gelukt. Dankjewel!\n\nIk wilde nog mijn complimenten geven voor de masterclass van gisteren. Ik heb menig gratis webinars gevolgd en vond die van jou echt wel de beste. Ben benieuwd naar de cursussen!\n\nGroeten, Jessica'
  };
  return <section className="mb-12" data-id="element-146">
      <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-147">
        Meer reacties van deelnemers
      </h2>

      <div className="space-y-3 mb-6" data-id="element-148">
        {testimonials.map((testimonial, index) => <div key={index} className="bg-gray-50 border border-gray-200 rounded-lg p-4" data-id="element-149">
            <div className="flex items-start" data-id="element-150">
              <div className={`w-8 h-8 ${testimonial.color} text-white rounded-full flex items-center justify-center font-bold mr-3 flex-shrink-0 text-sm`} data-id="element-151">
                {testimonial.initial}
              </div>
              <div className="flex-1" data-id="element-152">
                <div className="flex items-center justify-between mb-1" data-id="element-153">
                  <span className="font-semibold text-gray-900 text-sm" data-id="element-154">
                    {testimonial.name}
                  </span>
                  <span className="text-xs text-gray-500" data-id="element-155">
                    {testimonial.time}
                  </span>
                </div>
                <p className="text-gray-700 text-sm" data-id="element-156">{testimonial.text}</p>
              </div>
            </div>
          </div>)}
      </div>

      <div className="bg-white border border-gray-300 rounded-lg p-5" data-id="element-157">
        <div className="border-b border-gray-200 pb-3 mb-3" data-id="element-158">
          <p className="text-sm text-gray-600" data-id="element-159">
            <span className="font-semibold" data-id="element-160">{emailTestimonial.from}</span> aan{' '}
            {emailTestimonial.to}
          </p>
        </div>
        <p className="font-semibold text-gray-900 mb-3" data-id="element-161">
          {emailTestimonial.subject}
        </p>
        <p className="text-gray-700 leading-relaxed whitespace-pre-line text-sm" data-id="element-162">
          {emailTestimonial.text}
        </p>
      </div>
    </section>;
};